import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const CartProgress = ({ totalProgress, box, className = "" }) => {
	const { translation, cartSettings: { progress } } = useGlobalContext();
	const { activeBox } = useSelector((state) => state.cart);
	const currentBox = box || activeBox;
	const [showInitialMessage, setShowInitialMessage] = useState(true);

	const boxProgress = progress.box.find(s => s.value === currentBox?.size?.value);

	const activeStep = boxProgress?.steps?.length > 0 ? boxProgress.steps.find(s => s?.quantity > totalProgress) : {};

	useEffect(() => {
		// If activeStep has initialMessage, show it for 1.5 seconds
		if (activeStep?.initialMessage) {
			setShowInitialMessage(true);
			const timer = setTimeout(() => {
				setShowInitialMessage(false);
			}, 1500);
			return () => clearTimeout(timer);
		}
	}, [activeStep]);


	if (!boxProgress) return null;
	const productWidth = 100 / progress.max_products;
	const currentStep = boxProgress.steps.find(s => s?.quantity === totalProgress);
	const previousStep = boxProgress.steps
		.filter(s => s.quantity < totalProgress)
		.reduce((prevStep, currStep) => {
			if (!prevStep || currStep?.quantity > prevStep?.quantity) {
				return currStep;
			}
			return prevStep;
		}, null);

	const formatMessage = (msg) => {
		const difference = Math.round(activeStep.quantity - totalProgress);
		let message = msg.replace("{products}", difference);
		if (difference === 1) message = message.replace(translation.cart.products, translation.cart.product);
		return message;
	};

	return (
		<div className={clsx("p-0 mt-3", className)}>
			<p className="text-small text-[#00000099]">
				{showInitialMessage && activeStep?.initialMessage ?
					activeStep?.initialMessage :
					(activeStep?.message ? formatMessage(activeStep.message) : progress?.success_message)}
			</p>
			<div className="w-full mt-1 h-2.5 relative overflow-hidden rounded-[50px]">
				<div className="bg-[#E8E8E8] h-full w-full absolute left-0 top-0" />
				{previousStep?.quantity <= totalProgress && <div
					className="z-10 h-full absolute top-0 left-0 transition-width delay-300 ease-in-out bg-light-orange"
					style={{ width: `calc(${productWidth}%*${previousStep?.quantity})` }} />}
				<div
					className={clsx("h-full absolute top-0 left-0 transition-width delay-300 ease-in-out", 
						totalProgress === currentStep?.quantity ? "bg-light-orange" : "bg-light-orange opacity-30")}
					style={{ width: `calc(${productWidth}%*${totalProgress})` }} />
				<div className="w-full h-full absolute left-0 top-0">
					{boxProgress.steps.slice(0, -1).map((step, i) =>
						<span key={i}
							className="bg-[#F2FBF2] w-1 h-full absolute"
							style={{ left: `${step.quantity * productWidth}%` }}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default CartProgress;